import * as moment from "moment";

moment.locale("zh-cn");

// Set utils function parseTime to filter
export {parseTime, formatDateOrTime} from "@/utils";

// Filter to uppercase the first character
export const uppercaseFirstChar = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};

export const timeParser = (time: string, pattern?: string): string => {
    if (!time) {
        return '';
    }
    return moment.utc(time).local().format(pattern || "YYYY-MM-DD");
};

export const constParser = (val, cons: any[], key = "value", name = "name") => {
    const item = cons.find((item) => {
        if (item[key] === val) {
            return item;
        }
    });
    if (item) {
        return item[name] || val;
    }
    return val;
}
